import React, { createContext, useContext, useReducer } from 'react'
import reducer from './AllReducer';
import axios from 'axios';

const AllContext = createContext()

const initialState = {
    upcomingEvent: [],
    pastEvent: [],
    allEvents: [],
    allBattle: [],
    allInterestedEvent: [],
    userDetails: {},
    country: [],
    city: [],
    artType: [],
    artwork: [],
    participate: [],
    communicate: [],
    mediaType: [],
    tagCategoryKeyword: [],
    singleUserPost: []
}

const AllContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const getUpcomingEvent = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/GetUpcomingEvent`)
            const data = await response.data
            
            dispatch({ type: "setUpcomingEvent", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getPastEvent = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/GetPastEvent`)
            const data = await response.data
            
            dispatch({ type: "setPastEvent", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getAllEvents = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/AllEventGet`)
            const data = await response.data
            
            dispatch({ type: "setAllEvents", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getAllBattle = async (eventId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/EventByAllBattle/${eventId}`)
            const data = await response.data
            
            dispatch({ type: "setAllBattle", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const GetAllInterestedEvent = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/AllInterestedEvent`)
            const data = await response.data
            
            dispatch({ type: "setAllInterestedEvent", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getUserDetails = async (token, id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get_user/${id}`, {
                headers: {
                    Authorization: `${token}`
                }
            })
            const data = await response.data
            
            dispatch({ type: "setUserDetails", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getCountry = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/fetch-all-country`)
            const data = await response.data
            
            dispatch({ type: "setCountry", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getCity = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/fetch-all-city`)
            const data = await response.data
            
            dispatch({ type: "setCity", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getArtType = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/art-type-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setArtType", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getArtwork = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/art-work-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setArtwork", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getParticipate = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/participate-prefer-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setParticipate", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getCommunicate = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/communicate-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setCommunicate", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getMediaType = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/media-type-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setMediaType", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getTagCategoryKeyword = async (token) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tag-category-keyword-getAll`, {
                headers: {
                    Authorization: token
                }
            })
            const data = await response.data
            
            dispatch({ type: "setTagCategoryKeyword", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getAllUserPosts = async (token, id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user-post-getAll/${id}`, {
                headers: {
                    Authorization: `${token}`
                }
            })
            const data = await response.data
            
            dispatch({ type: "setAllUserPosts", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }

    const getSingleUserPost = async (token, id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/single-user-post-getAll/${id}`, {
                headers: {
                    Authorization: `${token}`
                }
            })
            const data = await response.data
            
            dispatch({ type: "setSingleUserPost", payload: data })
        } catch (error) {
            console.log("Error:", error);
        }
    }
  
    
    return <AllContext.Provider value={{...state, 
        getUpcomingEvent,
        getPastEvent,
        getAllEvents,
        getAllBattle,
        GetAllInterestedEvent,
        getUserDetails,
        getCountry,
        getCity,
        getArtType,
        getArtwork,
        getParticipate,
        getCommunicate,
        getMediaType,
        getTagCategoryKeyword,
        getAllUserPosts,
        getSingleUserPost
    }}>
        {children}
    </AllContext.Provider>
}

const useAllContext = () => {
    return useContext(AllContext)
}

export { AllContextProvider, useAllContext }